import { useState } from "react";
import { Button, Card, Checkbox, Stack, Text } from "@/components/ui";
import { useRolesDisponibles } from "../hooks/use-roles-disponibles";
import { useCambiarRoles } from "../hooks/use-usuarios-mutations";

/**
 * Editor de roles · checkboxes de TODOS los roles asignables (sistema +
 * personalizados · traídos del backend). State local para permitir cambios
 * pendientes (el usuario marca varios y guarda con un solo click).
 */
export function SeccionRoles({ usuarioId, rolesActuales }: { usuarioId: string; rolesActuales: string[] }) {
  const [sel, setSel] = useState<Set<string>>(new Set(rolesActuales));
  const rolesDisponibles = useRolesDisponibles();
  const guardar = useCambiarRoles();

  const toggle = (r: string) => {
    const next = new Set(sel);
    if (next.has(r)) next.delete(r);
    else next.add(r);
    setSel(next);
  };

  return (
    <Card padding="md">
      <Stack gap="sm">
        <Text size="xs" fw={600} className="uppercase tracking-wide" c="dimmed">
          Roles
        </Text>
        <Stack gap={6}>
          {/* Unión de los roles del catálogo + los que ya tiene el usuario (por si
              alguno fuera un rol viejo que ya no está en el catálogo). */}
          {Array.from(new Set([...rolesDisponibles, ...rolesActuales])).map((rol) => (
            <Checkbox key={rol} label={rol} checked={sel.has(rol)} onCheckedChange={() => toggle(rol)} />
          ))}
        </Stack>
        <Button size="xs" fullWidth loading={guardar.isPending} onClick={() => guardar.mutate({ usuarioId, roles: Array.from(sel) })}>
          Guardar roles
        </Button>
      </Stack>
    </Card>
  );
}
